import React, { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import VideoGrid from "./components/VideoGrid";
import OvertlySection from "./components/OvertlySection";
import MapSection from "./components/MapSection";
import AggregateSection from "./components/AggregateSection";
import ConscienceSection from "./components/ConscienceSection";
import ProductSection from "./components/ProductSection";
import { PASSWORD } from "./config";

export default function App() {
  const [activeSection, setActiveSection] = useState("home"); // "home", "overtly", "map", "aggregate", "conscience", "product"
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [password, setPassword] = useState("");
  const [accessGranted, setAccessGranted] = useState(false); // set false to enable login

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (password === PASSWORD) {
      setAccessGranted(true);
    } else {
      console.log("Incorrect password");
    }
  };

  if (!accessGranted) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <form onSubmit={handlePasswordSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border border-black outline-none text-center text-lg p-2"
            style={{ fontSize: "10px", height: "20px", width: "200px" }}
          />
          <button type="submit" className="hidden">
            Submit
          </button>
        </form>
      </div>
    );
  }

  const renderSection = () => {
    if (selectedProduct) {
      return (
        <ProductSection
          productNumber={selectedProduct}
          onBack={() => setSelectedProduct(null)}
        />
      );
    }

    switch (activeSection) {
      case "overtly":
        return <OvertlySection />;
      case "aggregate":
        return <AggregateSection onSelectProduct={setSelectedProduct} />;
      case "map":
        return <MapSection />;
      case "conscience":
        return <ConscienceSection />;
      default:
        return (
          <VideoGrid
            onOvertlyClick={() => setActiveSection("overtly")}
            onAggregateClick={() => setActiveSection("aggregate")}
            onConscienceClick={() => setActiveSection("conscience")}
            onMapClick={() => setActiveSection("map")}
          />
        );
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white text-black">
      {/* Hide Header/Footer if a product is selected */}
      {!selectedProduct && (
        <Header
          onOvertlyClick={() => setActiveSection("overtly")}
          onMapClick={() => setActiveSection("map")}
          onAggregateClick={() => setActiveSection("aggregate")}
          onConscienceClick={() => setActiveSection("conscience")}
          onLogoClick={() => {
            setActiveSection("home");
            setSelectedProduct(null);
          }}
        />
      )}

      {/* Body */}
      {renderSection()}

      {!selectedProduct && <Footer />}
    </div>
  );
}
